export const handleElasticProductSearchData = (data, store) => {
    let prodArr = {};
    data.forEach((element) => {
      let ele = element._source;
      // console.log('ele',store)
      if (prodArr[ele.product_id] && prodArr[ele.product_id].stocks ) {
        let item = prodArr[ele.product_id];
       console.log('look for stocks', item)
        let stocks = item.stocks;
        stocks.push({
          id: ele.product_id,
          salePrice: ele.stockSalePrice,
          inStock: ele.in_stock,
          name: ele.skuName,
          image: ele.skuImage,
          quantity: ele.quantity,
          skuLabel: ele.skuLabel,
          salePriceCurrency: ele.salePriceCurrency,
        });
        item.stocks = stocks;
        prodArr[ele.product_id] = item;
      } else if (ele.in_stock) {
        console.log(ele.product_name,'Inside - 2')
        let item = {
          name: ele.product_name,
          image: "https://res.cloudinary.com/grabbngo/image/upload/"+ele.product_image,
          id: ele.product_id,
          stocks: [],
          store: store,
          description: ele.product_description,
          contains: ele.contains,
          category: ele.category_id,
          stockSla: ele.stockSla,
          categoryName: ele.category_name,
          categoryDisplayOrder: ele.categoryDisplayOrder,
          isCustomizable: ele.isCustomizable,
          skuCardColor: ele.skuCardColor,
          skuFontColor: ele.skuFontColor,
          skuMask: ele.skuMask,
          storeName: ele.storeName,
          salePriceCurrency: 'INR',
          storeImage: ele.storeImage,
          skuId:ele.sku_id,
        };
        //console.log('print item', item);
        item.stocks.push({
          id:ele.stock_id,
          salePrice: ele.mrp,
          inStock: ele.in_stock,
          name: ele.sku_name,
          image: "https://res.cloudinary.com/grabbngo/image/upload/"+ele.sku_image,
          quantity: ele.variation,
          skuLabel: ele.skuLabel,
        });
        prodArr[ele.product_id] = item;
      }
    });
    let prods = Object.values(prodArr);
    //console.log('print prods', prods)
    if (prods && prods.length > 0) {
      prods = prods.map((prod) => { 
        prod.stocks.sort((a, b) => a.mrp - b.mrp);
        return prod;
      });
      prods.sort((a, b) => a.displayOrder - b.displayOrder);
      return {
        products: prods,
      };
    } else {
      return { products: [] };
    }
  };


// WEBPACK FOOTER //
// ./src/pages/InventoryManagement/handleElasticProductSearchData.js